import { Injectable } from '@angular/core';
import { GroupClassesPrivileges } from '@bayclubs/group-classes-employee-api';
import { Observable } from 'rxjs';
import { ManagementHttpClient } from '../../shared/services/management-http-client';

@Injectable({
    providedIn: 'root'
})
export class PrivilegesApiService {
    constructor(private http: ManagementHttpClient) {}

    public get(): Observable<GroupClassesPrivileges> {
        return this.http.get<GroupClassesPrivileges>('privileges', false);
    }
}
